import { Events } from "@/pages/events/view";
import { AlertsHistory } from "@/pages/history";
import { SharedMapForm } from "@/pages/mapForm";
import { Unauthorized } from "@/pages/unauthorized";
import Home from "../pages/home";
export const appRoutes = [
    { path: "/", component: Home },
    { path: "/eventos", component: Events },
    { path: "/historico", component: AlertsHistory, requiresAuth: true },
    { path: "/editar/:id", component: SharedMapForm, requiresAuth: true },
    { path: "/criar/:categoria", component: SharedMapForm, requiresAuth: true },
    { path: "/nao-autorizado", component: Unauthorized },
];
